import { faFacebook, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faBookMedical, faContactCard, faMessage, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FloatButton } from "antd";
import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../configurations/axiosInstance/AxiosInstance";
import { NavLink } from "react-router-dom";
import { ColorsContext } from "../../composants/colorContext";

const CustomFlagButton = ()=>{
  const {setColors} = useContext(ColorsContext);
  const [links, setLinks] = useState([]);
  const defaultLinks = [
    {
      key: `denonciation`,
      href: `/denonciation`,
      title: `Denonciation`,
      icon: faBookMedical
    }, 
  ]
  const fetchContact = ()=>{
      if(links.length === 0){
        axiosInstance()
          .get("public/api/parametres/get/links")
          .then((response)=>{
            setLinks([]);
            let data = response.data;
            if (data != null) {
              const datas = defaultLinks;
              if (response.data.call != null) {
                datas.push({
                  key: `call`,
                  href: `tel:${data.call.valeur}`,
                  title: `${data.call.valeur}`,
                  icon: faPhone
                })
              }
              if (data.facebook != null) {
                datas.push({
                  key: `facebook`,
                  href: `${data.facebook.valeur}`,
                  title: `${data.facebook.valeur}`,
                  icon: faFacebook
                })
              }
              if (data.sms != null) {
                datas.push({
                  key: `sms`,
                  href: `sms:${data.sms.valeur}`,
                  title: `${data.sms.valeur}`,
                  icon: faMessage
                })
              }
              if (data.tweeter != null) {
                datas.push({
                  key: `tweeter`,
                  href: `${data.tweeter.valeur}`,
                  title: `${data.tweeter.valeur}`,
                  icon: faTwitter
                })
              }
              if (data.whatsapp != null) {
                datas.push({
                  key: `whatsapp`,
                  href: `https://api.whatsapp.com/send?phone=${data.whatsapp.valeur}`,
                  title: `${data.whatsapp.valeur}`,
                  icon: faWhatsapp
                })
              }
              localStorage.setItem('COLOR_NAVBAR', (data.COLOR_NAVBAR_VITRINE != null) ? data.COLOR_NAVBAR_VITRINE.valeur : '#ffffffff');
              setColors(prevColors => ({
                ...prevColors,
                COLOR_NAVBAR: (data.COLOR_NAVBAR_VITRINE != null) ? data.COLOR_NAVBAR_VITRINE.valeur : '#ffffffff'
              }));

              localStorage.setItem('COLOR_HEADER', (data.COLOR_HEADER_VITRINE != null) ? data.COLOR_HEADER_VITRINE.valeur : '#ffffffff');
              setColors(prevColors => ({
                ...prevColors,
                COLOR_HEADER: (data.COLOR_HEADER_VITRINE != null) ? data.COLOR_HEADER_VITRINE.valeur : '#ffffffff'
              }));
              localStorage.setItem('COLOR_BODY', (data.COLOR_BODY_VITRINE != null) ? data.COLOR_BODY_VITRINE.valeur : '#ffffffff');
              setColors(prevColors => ({
                ...prevColors,
                COLOR_BODY: (data.COLOR_BODY_VITRINE != null) ? data.COLOR_BODY_VITRINE.valeur : '#ffffffff'
              }));
              setLinks([]);
              setLinks(datas);
            }
          }).catch((error)=>{
            setLinks(defaultLinks);
          })
      }
    }
    useEffect(()=>{fetchContact()},[]);

    return (
        <>
        <FloatButton.Group
          trigger="click"
          type="primary"
          style={{ insetInlineEnd: 24 }}
          tooltip={<p>Nous contacter</p>}
          icon={<FontAwesomeIcon icon={faContactCard} />}
        >
          {
            links.length != 0 &&  links.map(link =>{
              return <NavLink key={link.key} to={link.href} target={link.key === defaultLinks[0].key ? "_parent" : "_blank"}>
                <FloatButton tooltip={<p>{link.key}</p>} icon={<FontAwesomeIcon icon={link.icon} />} />
              </NavLink> 
            }) 
          }
         
        </FloatButton.Group>
  </>
    );
}

export default CustomFlagButton;